import { } from "jquery"
import { } from "bootstrap"
import { size } from "lodash"
import * as uuid from "uuid"
import { inspect } from "util"
import { ListResult, Asset, CreateAsset } from "../api/model"
import { AssetCategoryApi, AssetAreaApi, FacilityApi, AssetApi } from "../api/api"
import { UiUtils, JqElm, BigCountBox, GeneralElementCreator } from "./ui"
import { splitIgnoreEmpty } from "../utils/string"
import { CreateAssetTempStore } from '../store/temp_store'
import { AssetEditPageBase } from "./asset_edit_page_base"
export interface ValidationState {
    successIds: Array<string>
    failIds: Array<string>
}

/**
 * Main class to handle "**CreateAssetPage**" page UI elements, events, and actions
 */
export class CreateAssetPage extends AssetEditPageBase {

    rootContainerId: string = "asset_create_container"

    listenFormChangeEnabled = true
    createAssetItemCreator = new CreatAssetItemElementCreator()

    constructor(
        assetApi: AssetApi,
        assetCategoryApi: AssetCategoryApi,
        facilityApi: FacilityApi,
        assetAreaApi: AssetAreaApi,
        private tempStore: CreateAssetTempStore
    ) {
        super(assetApi, assetCategoryApi, facilityApi, assetAreaApi)
    }

    appendCreateAssetElm(id?: string): JqElm {
        this.listenFormChangeEnabled = false
        id = id ? id : uuid()
        const templateData = {
            id: id
        }
        const elm = this.createAssetItemCreator.createJqElm(templateData)
        elm.appendTo($(this.createAssetItemCreator.tmplElmId).parent())
        this.fillCategoryElmData(
            elm.find('select[name=categoryRootId]'),
            elm.find('select[name=categoryId]')
        )
        this.fillAreaElmData(elm.find('select[name=areaId]'))
        this.listenFormChangeEnabled = true
        return elm
    }

    initExcelFileUpload() {
        const fileElm = $('#excel_file')
        const uploadBtn = $('#excel_upload_btn')
        fileElm.change(e => {
            uploadBtn.button("loading")
            console.log("Changed")
            const f = <HTMLInputElement>fileElm[0]
            const file = f.files[0]
            console.log(f.files.length)
            let formData = new FormData()
            for (let i = 0; i < f.files.length; i++) {
                formData.append(`excelFiles[${i}]`, f.files[i])
            }
            fileElm.val("")
            this.assetApi.createByExcel(formData)
                .then(result => {
                    uploadBtn.button("reset")
                    console.log("Upload success")
                    this.fillExcelData(result.data)
                })
                .catch(e => {

                    switch(e.errorMessage)
                    {
                        case "主類":
                            UiUtils.alert("分類1 尚未新增，請前往【資產項目管理】新增分類後再重新下載預設表單進行批次匯入。")
                            break;
                        case "子類":
                            UiUtils.alert("分類2 欄位不可為空 或 尚未新增，請前往【資產項目管理】新增子分類後再重新下載預設表單進行批次匯入。")
                            break;
                        default:
                            UiUtils.alert("匯入檔案格式錯誤")
                    }
                    console.error(e);
                    uploadBtn.button("reset")
                })
        })

        uploadBtn.click(() => {
            fileElm.click()
        })
    }

    initNoteModal() {
        super.initNoteEditModal()
    }

    initCloneModal() {
        const page = this
        const modal = $('#clone_modal')
        const coutBox = new BigCountBox($('.big_count_box'), 1, 100000)
        modal.on('show.bs.modal', function (event) {
            coutBox.reset()
            var button = $(event.relatedTarget)
            var recordId = button.data('id')
            modal.data('id', recordId)
            const catSubElm = page.elmById(recordId, null, "categoryId")
            const areaElm = page.elmById(recordId, null, "areaId")
            const catName = page.assetBasicDataProvider.getCategoryName(Number(catSubElm.val()), '/')
            $('#clone_cat').text(catName)

            console.log(areaElm.val());
            if(areaElm.val()=="" ||areaElm.val()=="請選擇"  )
            {
                $('#clone_area').text("請選擇");
            }
            else
            {
                $('#clone_area').text(page.assetBasicDataProvider.areaMap[Number(areaElm.val())].name)
            }
        })

        $('#clone_modal_confirm').click(() => {
            const count = coutBox.val()
            var recordId = modal.data('id')
            const categoryRootId = page.elmById(recordId, null, "categoryRootId").val()
            const categoryId = page.elmById(recordId, null, "categoryId").val()
            const areaId = page.elmById(recordId, null, "areaId").val()

            for (let i = 0; i < count; i++) {
                const elm = page.appendCreateAssetElm()
                const id = elm.data('id')
                page.elmById(id, null, "categoryRootId").val(categoryRootId).change()
                page.elmById(id, null, "categoryId").val(categoryId).change()
                page.elmById(id, null, "areaId").val(areaId).change()
            }
        })
    }

    listenAddBtnClick() {
        $('#create_asset_add_btn').click(() => {
            this.appendCreateAssetElm()
        })
    }

    listenDeleteClick() {
        const selector = `.${this.createAssetItemCreator.classId} [name=delete]`
        $(document).on("click", selector, e => {
            const el = $(e.target)
            const createItemElm = el.parents(`.${this.createAssetItemCreator.classId}`)
            const recordId = createItemElm.data('id')
            createItemElm.remove()
            this.tempStore.remove(recordId)
            if ($(selector).length == 0) {
                this.appendCreateAssetElm()
            }
        })
    }

    listenFormChange() {
        $(document).on("change", `.${this.createAssetItemCreator.classId} input,select`, e => {
            if (this.listenFormChangeEnabled) {
                const elm = $(e.target)
                const createItemElm = $(elm.parents(`.${this.createAssetItemCreator.classId}`)[0])
                this.updateDataRow(createItemElm)
            }
        })
    }

    listenCreateClick() {
        $('#create_asset_submit').click(e => {
            const btnElm = $(e.target)
            const rt = this.createAsset()
            rt.then(rt => {
                btnElm.button("reset")
            }).catch(r => {
                btnElm.button("reset")
            })
        })
    }

    listenShortcutLinks() {
        $('#backpage').prop('href', 'assetMain.aspx')
        $('#goto_item_mgt_btn').click(e => {
            location.href = "assetItem.aspx"
        })
        $('#goto_list_btn').click(e => {
            location.href = "assetList.aspx"
        })
    }

    restoreTempData() {
        const excludNames = [""]
        const root = this.tempStore.getRoot()
        /*
        const assets = Object.entries(root.items).map(it => {
            it[1].id = it[0]
            return <Asset>it[1]
        })
        super.fillEditAssetData(assets, this.appendCreateAssetElm.bind(this)) 
        */
        $(`.${this.createAssetItemCreator.classId}`).remove()
        Object.entries(root.items).forEach(([id, item]) => {
            console.log("Stored item:%s", inspect(item))
            const elm = this.appendCreateAssetElm(id)
            elm.find('input, select').toArray().map($).forEach(elm => {
                const name: string = elm.prop('name').toString()
                if (!name.startsWith('type_')) {
                    switch (name) {
                        case 'guestLoanable':
                            if (item.guestLoanable) {
                                UiUtils.setChecked(elm).change()
                            }
                            break
                        default:
                            elm.val(item[name]).change()
                    }
                }
            })
            const typeElm = elm.find(`#type_${item.type}_${id}`)
            UiUtils.setChecked(typeElm).change()
            if (item.facilityIds.length > 0) {
                UiUtils.setChecked(elm.find(`[name=facilityEnable]`)).change()
            }
        })

    }

    listenExcelTemplateDownloadClick() {
        $('#excel_template_download_btn').click(() => {

            this.assetApi.CheckCategoryFinder().then(result => {
                
                if(result == "success")
                {
                    location.href = this.assetApi.getExcelTemplateDownloadLink();
                } else
                {
                    UiUtils.alert(`【資產分類設定】尚有分類{ ${result} } 未新增子分類項目，請前往【資產項目管理】新增後再下載預設表單進行批次匯入。`);
                }
            });
        })
    }

    async createAsset(): Promise<void> {
        const validationState = this.validateData()
        if (validationState.failIds.length > 0 || validationState.successIds.length == 0) {
            return Promise.resolve(null)
        }
        $('#create_asset_submit').button('loading')
        const itemData = this.tempStore.getRoot().items
        const assetsToCreate = validationState
            .successIds
            .map(it => itemData[it])
            .map(it => {
                const createAsset: CreateAsset = {
                    name: it.name,
                    categoryId: it.categoryId != null ? Number(it.categoryId) : null,
                    areaId: Number(it.areaId),
                    status: it.status,
                    quantity: Number(it.quantity),
                    type: it.type,
                }
                if (it.guestLoanable) {
                    createAsset.guestLoanable = true
                }
                if (it.note.length > 0) {
                    createAsset.note = it.note
                }
                if (it.communityAssignId.length > 0) {
                    createAsset.communityAssignId = it.communityAssignId
                }
                if (it.facilityIds.length > 0) {
                    const facilityIds = splitIgnoreEmpty(it.facilityIds, ',')
                    createAsset.facilityIds = facilityIds
                }
                //facilityIds
                console.log(createAsset)
                return createAsset
            })
        try {
            await this.assetApi.create(assetsToCreate)
            UiUtils.alert("資產新增成功")
            this.cleanTempData()
            $(`.${this.createAssetItemCreator.classId}`).remove()
            this.appendCreateAssetElm()
        } catch (e) {
            UiUtils.alertIfClientError(e)
        }
    }

    cleanTempData() {
        this.tempStore.initRoot()
    }

    hasTempData(): boolean {
        return size(this.tempStore.getRoot().items) > 0
    }

    private updateDataRow(createItemElm: JqElm) {
        const id = createItemElm.data('id')
        const data: any = {}
        createItemElm
            .find('input, select')
            .toArray()
            .map($)
            .forEach(elm => {
                const name: string = elm.prop('name').toString()
                if (name.startsWith('type_')) {
                    if (UiUtils.isChecked(elm)) {
                        data['type'] = elm.val()
                    }
                } else {
                    if (name == 'guestLoanable') {
                        data[name] = UiUtils.isChecked(elm)
                    } else {
                        data[name] = elm.val()
                    }
                }
            })
        this.tempStore.add(id, data)
    }

    private fillExcelData(assets: Array<Asset>) {
        if (assets.length == 0) {
            return
        }
        if (!this.hasTempData()) { //Remove the "inited empty item"
            console.log("No temp data")
            $(`.${this.createAssetItemCreator.classId}`).remove()
        }
        super.fillEditAssetData(assets, this.appendCreateAssetElm.bind(this))
        this.validateData()
    }

    private validateData(): ValidationState {

        const state: ValidationState = {
            successIds: Array(),
            failIds: Array()
        }
        $(`.${this.createAssetItemCreator.classId}`)
            .toArray()
            .map($)
            .forEach(it => {
                const valid = this.validateItemData(it)
                const ids = valid ? state.successIds : state.failIds
                ids.push(it.data('id'))
            })
        return state
    }

}

export class CreatAssetItemElementCreator extends GeneralElementCreator {
    classId: string = 'create_asset_item'
}